// Danish postnumre people can live at (1000-3799 and 4000-9999), for the postnummer picker on the customer page.
// Built 2026-11-02 from https://da.wikipedia.org/wiki/Postnumre_i_Danmark, with names taken from
// Klimadatastyrelsen's address register (adressevaelger.dk) where it knows the postnummer.
// Left out: codes below 1000, the Faroe Islands and Greenland (3800-3999), company, PO box, parcel box and closed codes.
// Copenhagen's street ranges (e.g. 1650-1782 København V) are expanded, so a few numbers in them may not be in use.
import type { Postnummer } from '@/types'

export const postnumre: Postnummer[] = [
  { nr: '1001', navn: 'København K' },
  { nr: '1002', navn: 'København K' },
  { nr: '1003', navn: 'København K' },
  { nr: '1004', navn: 'København K' },
  { nr: '1005', navn: 'København K' },
  { nr: '1006', navn: 'København K' },
  { nr: '1007', navn: 'København K' },
  { nr: '1008', navn: 'København K' },
  { nr: '1009', navn: 'København K' },
  { nr: '1010', navn: 'København K' },
  { nr: '1011', navn: 'København K' },
  { nr: '1012', navn: 'København K' },
  { nr: '1013', navn: 'København K' },
  { nr: '1014', navn: 'København K' },
  { nr: '1015', navn: 'København K' },
  { nr: '1016', navn: 'København K' },
  { nr: '1017', navn: 'København K' },
  { nr: '1018', navn: 'København K' },
  { nr: '1019', navn: 'København K' },
  { nr: '1020', navn: 'København K' },
  { nr: '1021', navn: 'København K' },
  { nr: '1022', navn: 'København K' },
  { nr: '1023', navn: 'København K' },
  { nr: '1024', navn: 'København K' },
  { nr: '1025', navn: 'København K' },
  { nr: '1026', navn: 'København K' },
  { nr: '1027', navn: 'København K' },
  { nr: '1028', navn: 'København K' },
  { nr: '1029', navn: 'København K' },
  { nr: '1030', navn: 'København K' },
  { nr: '1031', navn: 'København K' },
  { nr: '1032', navn: 'København K' },
  { nr: '1033', navn: 'København K' },
  { nr: '1034', navn: 'København K' },
  { nr: '1035', navn: 'København K' },
  { nr: '1036', navn: 'København K' },
  { nr: '1037', navn: 'København K' },
  { nr: '1038', navn: 'København K' },
  { nr: '1039', navn: 'København K' },
  { nr: '1040', navn: 'København K' },
  { nr: '1041', navn: 'København K' },
  { nr: '1042', navn: 'København K' },
  { nr: '1043', navn: 'København K' },
  { nr: '1044', navn: 'København K' },
  { nr: '1045', navn: 'København K' },
  { nr: '1046', navn: 'København K' },
  { nr: '1047', navn: 'København K' },
  { nr: '1048', navn: 'København K' },
  { nr: '1049', navn: 'København K' },
  { nr: '1050', navn: 'København K' },
  { nr: '1051', navn: 'København K' },
  { nr: '1052', navn: 'København K' },
  { nr: '1053', navn: 'København K' },
  { nr: '1054', navn: 'København K' },
  { nr: '1055', navn: 'København K' },
  { nr: '1056', navn: 'København K' },
  { nr: '1057', navn: 'København K' },
  { nr: '1058', navn: 'København K' },
  { nr: '1059', navn: 'København K' },
  { nr: '1060', navn: 'København K' },
  { nr: '1061', navn: 'København K' },
  { nr: '1062', navn: 'København K' },
  { nr: '1063', navn: 'København K' },
  { nr: '1064', navn: 'København K' },
  { nr: '1065', navn: 'København K' },
  { nr: '1066', navn: 'København K' },
  { nr: '1067', navn: 'København K' },
  { nr: '1068', navn: 'København K' },
  { nr: '1069', navn: 'København K' },
  { nr: '1070', navn: 'København K' },
  { nr: '1071', navn: 'København K' },
  { nr: '1072', navn: 'København K' },
  { nr: '1073', navn: 'København K' },
  { nr: '1074', navn: 'København K' },
  { nr: '1100', navn: 'København K' },
  { nr: '1101', navn: 'København K' },
  { nr: '1102', navn: 'København K' },
  { nr: '1103', navn: 'København K' },
  { nr: '1104', navn: 'København K' },
  { nr: '1105', navn: 'København K' },
  { nr: '1106', navn: 'København K' },
  { nr: '1107', navn: 'København K' },
  { nr: '1108', navn: 'København K' },
  { nr: '1109', navn: 'København K' },
  { nr: '1110', navn: 'København K' },
  { nr: '1111', navn: 'København K' },
  { nr: '1112', navn: 'København K' },
  { nr: '1113', navn: 'København K' },
  { nr: '1114', navn: 'København K' },
  { nr: '1115', navn: 'København K' },
  { nr: '1116', navn: 'København K' },
  { nr: '1117', navn: 'København K' },
  { nr: '1118', navn: 'København K' },
  { nr: '1119', navn: 'København K' },
  { nr: '1120', navn: 'København K' },
  { nr: '1121', navn: 'København K' },
  { nr: '1122', navn: 'København K' },
  { nr: '1123', navn: 'København K' },
  { nr: '1124', navn: 'København K' },
  { nr: '1125', navn: 'København K' },
  { nr: '1126', navn: 'København K' },
  { nr: '1127', navn: 'København K' },
  { nr: '1128', navn: 'København K' },
  { nr: '1129', navn: 'København K' },
  { nr: '1130', navn: 'København K' },
  { nr: '1131', navn: 'København K' },
  { nr: '1150', navn: 'København K' },
  { nr: '1151', navn: 'København K' },
  { nr: '1152', navn: 'København K' },
  { nr: '1153', navn: 'København K' },
  { nr: '1154', navn: 'København K' },
  { nr: '1155', navn: 'København K' },
  { nr: '1156', navn: 'København K' },
  { nr: '1157', navn: 'København K' },
  { nr: '1158', navn: 'København K' },
  { nr: '1159', navn: 'København K' },
  { nr: '1160', navn: 'København K' },
  { nr: '1161', navn: 'København K' },
  { nr: '1162', navn: 'København K' },
  { nr: '1163', navn: 'København K' },
  { nr: '1164', navn: 'København K' },
  { nr: '1165', navn: 'København K' },
  { nr: '1166', navn: 'København K' },
  { nr: '1167', navn: 'København K' },
  { nr: '1168', navn: 'København K' },
  { nr: '1169', navn: 'København K' },
  { nr: '1170', navn: 'København K' },
  { nr: '1171', navn: 'København K' },
  { nr: '1172', navn: 'København K' },
  { nr: '1173', navn: 'København K' },
  { nr: '1174', navn: 'København K' },
  { nr: '1175', navn: 'København K' },
  { nr: '1176', navn: 'København K' },
  { nr: '1177', navn: 'København K' },
  { nr: '1178', navn: 'København K' },
  { nr: '1179', navn: 'København K' },
  { nr: '1180', navn: 'København K' },
  { nr: '1181', navn: 'København K' },
  { nr: '1182', navn: 'København K' },
  { nr: '1183', navn: 'København K' },
  { nr: '1184', navn: 'København K' },
  { nr: '1185', navn: 'København K' },
  { nr: '1186', navn: 'København K' },
  { nr: '1187', navn: 'København K' },
  { nr: '1188', navn: 'København K' },
  { nr: '1189', navn: 'København K' },
  { nr: '1190', navn: 'København K' },
  { nr: '1191', navn: 'København K' },
  { nr: '1192', navn: 'København K' },
  { nr: '1193', navn: 'København K' },
  { nr: '1194', navn: 'København K' },
  { nr: '1195', navn: 'København K' },
  { nr: '1196', navn: 'København K' },
  { nr: '1197', navn: 'København K' },
  { nr: '1198', navn: 'København K' },
  { nr: '1199', navn: 'København K' },
  { nr: '1200', navn: 'København K' },
  { nr: '1201', navn: 'København K' },
  { nr: '1202', navn: 'København K' },
  { nr: '1203', navn: 'København K' },
  { nr: '1204', navn: 'København K' },
  { nr: '1205', navn: 'København K' },
  { nr: '1206', navn: 'København K' },
  { nr: '1207', navn: 'København K' },
  { nr: '1208', navn: 'København K' },
  { nr: '1209', navn: 'København K' },
  { nr: '1210', navn: 'København K' },
  { nr: '1211', navn: 'København K' },
  { nr: '1212', navn: 'København K' },
  { nr: '1213', navn: 'København K' },
  { nr: '1214', navn: 'København K' },
  { nr: '1215', navn: 'København K' },
  { nr: '1216', navn: 'København K' },
  { nr: '1217', navn: 'København K' },
  { nr: '1218', navn: 'København K' },
  { nr: '1219', navn: 'København K' },
  { nr: '1220', navn: 'København K' },
  { nr: '1221', navn: 'København K' },
  { nr: '1250', navn: 'København K' },
  { nr: '1251', navn: 'København K' },
  { nr: '1252', navn: 'København K' },
  { nr: '1253', navn: 'København K' },
  { nr: '1254', navn: 'København K' },
  { nr: '1255', navn: 'København K' },
  { nr: '1256', navn: 'København K' },
  { nr: '1257', navn: 'København K' },
  { nr: '1258', navn: 'København K' },
  { nr: '1259', navn: 'København K' },
  { nr: '1260', navn: 'København K' },
  { nr: '1261', navn: 'København K' },
  { nr: '1262', navn: 'København K' },
  { nr: '1263', navn: 'København K' },
  { nr: '1264', navn: 'København K' },
  { nr: '1265', navn: 'København K' },
  { nr: '1266', navn: 'København K' },
  { nr: '1267', navn: 'København K' },
  { nr: '1268', navn: 'København K' },
  { nr: '1269', navn: 'København K' },
  { nr: '1270', navn: 'København K' },
  { nr: '1300', navn: 'København K' },
  { nr: '1301', navn: 'København K' },
  { nr: '1302', navn: 'København K' },
  { nr: '1303', navn: 'København K' },
  { nr: '1304', navn: 'København K' },
  { nr: '1305', navn: 'København K' },
  { nr: '1306', navn: 'København K' },
  { nr: '1307', navn: 'København K' },
  { nr: '1308', navn: 'København K' },
  { nr: '1309', navn: 'København K' },
  { nr: '1310', navn: 'København K' },
  { nr: '1312', navn: 'København K' },
  { nr: '1313', navn: 'København K' },
  { nr: '1314', navn: 'København K' },
  { nr: '1315', navn: 'København K' },
  { nr: '1316', navn: 'København K' },
  { nr: '1317', navn: 'København K' },
  { nr: '1318', navn: 'København K' },
  { nr: '1319', navn: 'København K' },
  { nr: '1320', navn: 'København K' },
  { nr: '1321', navn: 'København K' },
  { nr: '1322', navn: 'København K' },
  { nr: '1323', navn: 'København K' },
  { nr: '1324', navn: 'København K' },
  { nr: '1325', navn: 'København K' },
  { nr: '1326', navn: 'København K' },
  { nr: '1327', navn: 'København K' },
  { nr: '1328', navn: 'København K' },
  { nr: '1329', navn: 'København K' },
  { nr: '1350', navn: 'København K' },
  { nr: '1351', navn: 'København K' },
  { nr: '1352', navn: 'København K' },
  { nr: '1353', navn: 'København K' },
  { nr: '1354', navn: 'København K' },
  { nr: '1355', navn: 'København K' },
  { nr: '1356', navn: 'København K' },
  { nr: '1357', navn: 'København K' },
  { nr: '1358', navn: 'København K' },
  { nr: '1359', navn: 'København K' },
  { nr: '1360', navn: 'København K' },
  { nr: '1361', navn: 'København K' },
  { nr: '1362', navn: 'København K' },
  { nr: '1363', navn: 'København K' },
  { nr: '1364', navn: 'København K' },
  { nr: '1365', navn: 'København K' },
  { nr: '1366', navn: 'København K' },
  { nr: '1367', navn: 'København K' },
  { nr: '1368', navn: 'København K' },
  { nr: '1369', navn: 'København K' },
  { nr: '1370', navn: 'København K' },
  { nr: '1371', navn: 'København K' },
  { nr: '1372', navn: 'København K' },
  { nr: '1373', navn: 'København K' },
  { nr: '1374', navn: 'København K' },
  { nr: '1375', navn: 'København K' },
  { nr: '1376', navn: 'København K' },
  { nr: '1377', navn: 'København K' },
  { nr: '1378', navn: 'København K' },
  { nr: '1379', navn: 'København K' },
  { nr: '1380', navn: 'København K' },
  { nr: '1381', navn: 'København K' },
  { nr: '1382', navn: 'København K' },
  { nr: '1383', navn: 'København K' },
  { nr: '1384', navn: 'København K' },
  { nr: '1385', navn: 'København K' },
  { nr: '1386', navn: 'København K' },
  { nr: '1387', navn: 'København K' },
  { nr: '1388', navn: 'København K' },
  { nr: '1389', navn: 'København K' },
  { nr: '1391', navn: 'København K' },
  { nr: '1392', navn: 'København K' },
  { nr: '1393', navn: 'København K' },
  { nr: '1394', navn: 'København K' },
  { nr: '1395', navn: 'København K' },
  { nr: '1396', navn: 'København K' },
  { nr: '1397', navn: 'København K' },
  { nr: '1398', navn: 'København K' },
  { nr: '1400', navn: 'København K' },
  { nr: '1401', navn: 'København K' },
  { nr: '1402', navn: 'København K' },
  { nr: '1403', navn: 'København K' },
  { nr: '1404', navn: 'København K' },
  { nr: '1405', navn: 'København K' },
  { nr: '1406', navn: 'København K' },
  { nr: '1407', navn: 'København K' },
  { nr: '1408', navn: 'København K' },
  { nr: '1409', navn: 'København K' },
  { nr: '1410', navn: 'København K' },
  { nr: '1411', navn: 'København K' },
  { nr: '1412', navn: 'København K' },
  { nr: '1413', navn: 'København K' },
  { nr: '1414', navn: 'København K' },
  { nr: '1415', navn: 'København K' },
  { nr: '1416', navn: 'København K' },
  { nr: '1417', navn: 'København K' },
  { nr: '1418', navn: 'København K' },
  { nr: '1419', navn: 'København K' },
  { nr: '1420', navn: 'København K' },
  { nr: '1421', navn: 'København K' },
  { nr: '1422', navn: 'København K' },
  { nr: '1423', navn: 'København K' },
  { nr: '1424', navn: 'København K' },
  { nr: '1425', navn: 'København K' },
  { nr: '1426', navn: 'København K' },
  { nr: '1427', navn: 'København K' },
  { nr: '1428', navn: 'København K' },
  { nr: '1429', navn: 'København K' },
  { nr: '1430', navn: 'København K' },
  { nr: '1431', navn: 'København K' },
  { nr: '1432', navn: 'København K' },
  { nr: '1433', navn: 'København K' },
  { nr: '1434', navn: 'København K' },
  { nr: '1435', navn: 'København K' },
  { nr: '1436', navn: 'København K' },
  { nr: '1437', navn: 'København K' },
  { nr: '1438', navn: 'København K' },
  { nr: '1439', navn: 'København K' },
  { nr: '1440', navn: 'København K' },
  { nr: '1441', navn: 'København K' },
  { nr: '1450', navn: 'København K' },
  { nr: '1451', navn: 'København K' },
  { nr: '1452', navn: 'København K' },
  { nr: '1453', navn: 'København K' },
  { nr: '1454', navn: 'København K' },
  { nr: '1455', navn: 'København K' },
  { nr: '1456', navn: 'København K' },
  { nr: '1457', navn: 'København K' },
  { nr: '1458', navn: 'København K' },
  { nr: '1459', navn: 'København K' },
  { nr: '1460', navn: 'København K' },
  { nr: '1461', navn: 'København K' },
  { nr: '1462', navn: 'København K' },
  { nr: '1463', navn: 'København K' },
  { nr: '1464', navn: 'København K' },
  { nr: '1465', navn: 'København K' },
  { nr: '1466', navn: 'København K' },
  { nr: '1467', navn: 'København K' },
  { nr: '1468', navn: 'København K' },
  { nr: '1469', navn: 'København K' },
  { nr: '1470', navn: 'København K' },
  { nr: '1471', navn: 'København K' },
  { nr: '1472', navn: 'København K' },
  { nr: '1473', navn: 'København K' },
  { nr: '1501', navn: 'København V' },
  { nr: '1502', navn: 'København V' },
  { nr: '1503', navn: 'København V' },
  { nr: '1504', navn: 'København V' },
  { nr: '1505', navn: 'København V' },
  { nr: '1506', navn: 'København V' },
  { nr: '1507', navn: 'København V' },
  { nr: '1508', navn: 'København V' },
  { nr: '1509', navn: 'København V' },
  { nr: '1510', navn: 'København V' },
  { nr: '1550', navn: 'København V' },
  { nr: '1551', navn: 'København V' },
  { nr: '1552', navn: 'København V' },
  { nr: '1553', navn: 'København V' },
  { nr: '1554', navn: 'København V' },
  { nr: '1555', navn: 'København V' },
  { nr: '1556', navn: 'København V' },
  { nr: '1557', navn: 'København V' },
  { nr: '1558', navn: 'København V' },
  { nr: '1559', navn: 'København V' },
  { nr: '1560', navn: 'København V' },
  { nr: '1561', navn: 'København V' },
  { nr: '1562', navn: 'København V' },
  { nr: '1563', navn: 'København V' },
  { nr: '1564', navn: 'København V' },
  { nr: '1567', navn: 'København V' },
  { nr: '1568', navn: 'København V' },
  { nr: '1569', navn: 'København V' },
  { nr: '1570', navn: 'København V' },
  { nr: '1571', navn: 'København V' },
  { nr: '1572', navn: 'København V' },
  { nr: '1573', navn: 'København V' },
  { nr: '1574', navn: 'København V' },
  { nr: '1575', navn: 'København V' },
  { nr: '1576', navn: 'København V' },
  { nr: '1577', navn: 'København V' },
  { nr: '1600', navn: 'København V' },
  { nr: '1601', navn: 'København V' },
  { nr: '1602', navn: 'København V' },
  { nr: '1603', navn: 'København V' },
  { nr: '1604', navn: 'København V' },
  { nr: '1605', navn: 'København V' },
  { nr: '1606', navn: 'København V' },
  { nr: '1607', navn: 'København V' },
  { nr: '1608', navn: 'København V' },
  { nr: '1609', navn: 'København V' },
  { nr: '1610', navn: 'København V' },
  { nr: '1611', navn: 'København V' },
  { nr: '1612', navn: 'København V' },
  { nr: '1613', navn: 'København V' },
  { nr: '1614', navn: 'København V' },
  { nr: '1615', navn: 'København V' },
  { nr: '1616', navn: 'København V' },
  { nr: '1617', navn: 'København V' },
  { nr: '1618', navn: 'København V' },
  { nr: '1619', navn: 'København V' },
  { nr: '1620', navn: 'København V' },
  { nr: '1621', navn: 'København V' },
  { nr: '1622', navn: 'København V' },
  { nr: '1623', navn: 'København V' },
  { nr: '1624', navn: 'København V' },
  { nr: '1631', navn: 'København V' },
  { nr: '1632', navn: 'København V' },
  { nr: '1633', navn: 'København V' },
  { nr: '1634', navn: 'København V' },
  { nr: '1635', navn: 'København V' },
  { nr: '1650', navn: 'København V' },
  { nr: '1651', navn: 'København V' },
  { nr: '1652', navn: 'København V' },
  { nr: '1653', navn: 'København V' },
  { nr: '1654', navn: 'København V' },
  { nr: '1655', navn: 'København V' },
  { nr: '1656', navn: 'København V' },
  { nr: '1657', navn: 'København V' },
  { nr: '1658', navn: 'København V' },
  { nr: '1659', navn: 'København V' },
  { nr: '1660', navn: 'København V' },
  { nr: '1661', navn: 'København V' },
  { nr: '1662', navn: 'København V' },
  { nr: '1663', navn: 'København V' },
  { nr: '1664', navn: 'København V' },
  { nr: '1665', navn: 'København V' },
  { nr: '1666', navn: 'København V' },
  { nr: '1667', navn: 'København V' },
  { nr: '1668', navn: 'København V' },
  { nr: '1669', navn: 'København V' },
  { nr: '1670', navn: 'København V' },
  { nr: '1671', navn: 'København V' },
  { nr: '1672', navn: 'København V' },
  { nr: '1673', navn: 'København V' },
  { nr: '1674', navn: 'København V' },
  { nr: '1675', navn: 'København V' },
  { nr: '1676', navn: 'København V' },
  { nr: '1677', navn: 'København V' },
  { nr: '1678', navn: 'København V' },
  { nr: '1679', navn: 'København V' },
  { nr: '1680', navn: 'København V' },
  { nr: '1681', navn: 'København V' },
  { nr: '1682', navn: 'København V' },
  { nr: '1683', navn: 'København V' },
  { nr: '1684', navn: 'København V' },
  { nr: '1685', navn: 'København V' },
  { nr: '1686', navn: 'København V' },
  { nr: '1687', navn: 'København V' },
  { nr: '1688', navn: 'København V' },
  { nr: '1689', navn: 'København V' },
  { nr: '1690', navn: 'København V' },
  { nr: '1691', navn: 'København V' },
  { nr: '1692', navn: 'København V' },
  { nr: '1693', navn: 'København V' },
  { nr: '1694', navn: 'København V' },
  { nr: '1695', navn: 'København V' },
  { nr: '1696', navn: 'København V' },
  { nr: '1697', navn: 'København V' },
  { nr: '1698', navn: 'København V' },
  { nr: '1699', navn: 'København V' },
  { nr: '1700', navn: 'København V' },
  { nr: '1701', navn: 'København V' },
  { nr: '1702', navn: 'København V' },
  { nr: '1703', navn: 'København V' },
  { nr: '1704', navn: 'København V' },
  { nr: '1705', navn: 'København V' },
  { nr: '1706', navn: 'København V' },
  { nr: '1707', navn: 'København V' },
  { nr: '1708', navn: 'København V' },
  { nr: '1709', navn: 'København V' },
  { nr: '1710', navn: 'København V' },
  { nr: '1711', navn: 'København V' },
  { nr: '1712', navn: 'København V' },
  { nr: '1713', navn: 'København V' },
  { nr: '1714', navn: 'København V' },
  { nr: '1715', navn: 'København V' },
  { nr: '1716', navn: 'København V' },
  { nr: '1717', navn: 'København V' },
  { nr: '1718', navn: 'København V' },
  { nr: '1719', navn: 'København V' },
  { nr: '1720', navn: 'København V' },
  { nr: '1721', navn: 'København V' },
  { nr: '1722', navn: 'København V' },
  { nr: '1723', navn: 'København V' },
  { nr: '1724', navn: 'København V' },
  { nr: '1725', navn: 'København V' },
  { nr: '1726', navn: 'København V' },
  { nr: '1727', navn: 'København V' },
  { nr: '1728', navn: 'København V' },
  { nr: '1729', navn: 'København V' },
  { nr: '1730', navn: 'København V' },
  { nr: '1731', navn: 'København V' },
  { nr: '1732', navn: 'København V' },
  { nr: '1733', navn: 'København V' },
  { nr: '1734', navn: 'København V' },
  { nr: '1735', navn: 'København V' },
  { nr: '1736', navn: 'København V' },
  { nr: '1737', navn: 'København V' },
  { nr: '1738', navn: 'København V' },
  { nr: '1739', navn: 'København V' },
  { nr: '1740', navn: 'København V' },
  { nr: '1741', navn: 'København V' },
  { nr: '1742', navn: 'København V' },
  { nr: '1743', navn: 'København V' },
  { nr: '1744', navn: 'København V' },
  { nr: '1745', navn: 'København V' },
  { nr: '1746', navn: 'København V' },
  { nr: '1747', navn: 'København V' },
  { nr: '1748', navn: 'København V' },
  { nr: '1749', navn: 'København V' },
  { nr: '1750', navn: 'København V' },
  { nr: '1751', navn: 'København V' },
  { nr: '1752', navn: 'København V' },
  { nr: '1753', navn: 'København V' },
  { nr: '1754', navn: 'København V' },
  { nr: '1755', navn: 'København V' },
  { nr: '1756', navn: 'København V' },
  { nr: '1757', navn: 'København V' },
  { nr: '1758', navn: 'København V' },
  { nr: '1759', navn: 'København V' },
  { nr: '1760', navn: 'København V' },
  { nr: '1761', navn: 'København V' },
  { nr: '1762', navn: 'København V' },
  { nr: '1763', navn: 'København V' },
  { nr: '1764', navn: 'København V' },
  { nr: '1765', navn: 'København V' },
  { nr: '1766', navn: 'København V' },
  { nr: '1767', navn: 'København V' },
  { nr: '1768', navn: 'København V' },
  { nr: '1769', navn: 'København V' },
  { nr: '1770', navn: 'København V' },
  { nr: '1771', navn: 'København V' },
  { nr: '1772', navn: 'København V' },
  { nr: '1773', navn: 'København V' },
  { nr: '1774', navn: 'København V' },
  { nr: '1775', navn: 'København V' },
  { nr: '1776', navn: 'København V' },
  { nr: '1777', navn: 'København V' },
  { nr: '1778', navn: 'København V' },
  { nr: '1779', navn: 'København V' },
  { nr: '1780', navn: 'København V' },
  { nr: '1781', navn: 'København V' },
  { nr: '1782', navn: 'København V' },
  { nr: '1800', navn: 'Frederiksberg C' },
  { nr: '1801', navn: 'Frederiksberg C' },
  { nr: '1802', navn: 'Frederiksberg C' },
  { nr: '1803', navn: 'Frederiksberg C' },
  { nr: '1804', navn: 'Frederiksberg C' },
  { nr: '1805', navn: 'Frederiksberg C' },
  { nr: '1806', navn: 'Frederiksberg C' },
  { nr: '1807', navn: 'Frederiksberg C' },
  { nr: '1808', navn: 'Frederiksberg C' },
  { nr: '1809', navn: 'Frederiksberg C' },
  { nr: '1810', navn: 'Frederiksberg C' },
  { nr: '1811', navn: 'Frederiksberg C' },
  { nr: '1812', navn: 'Frederiksberg C' },
  { nr: '1813', navn: 'Frederiksberg C' },
  { nr: '1814', navn: 'Frederiksberg C' },
  { nr: '1815', navn: 'Frederiksberg C' },
  { nr: '1816', navn: 'Frederiksberg C' },
  { nr: '1817', navn: 'Frederiksberg C' },
  { nr: '1818', navn: 'Frederiksberg C' },
  { nr: '1819', navn: 'Frederiksberg C' },
  { nr: '1820', navn: 'Frederiksberg C' },
  { nr: '1821', navn: 'Frederiksberg C' },
  { nr: '1822', navn: 'Frederiksberg C' },
  { nr: '1823', navn: 'Frederiksberg C' },
  { nr: '1824', navn: 'Frederiksberg C' },
  { nr: '1825', navn: 'Frederiksberg C' },
  { nr: '1826', navn: 'Frederiksberg C' },
  { nr: '1827', navn: 'Frederiksberg C' },
  { nr: '1828', navn: 'Frederiksberg C' },
  { nr: '1829', navn: 'Frederiksberg C' },
  { nr: '1830', navn: 'Frederiksberg C' },
  { nr: '1831', navn: 'Frederiksberg C' },
  { nr: '1832', navn: 'Frederiksberg C' },
  { nr: '1833', navn: 'Frederiksberg C' },
  { nr: '1834', navn: 'Frederiksberg C' },
  { nr: '1835', navn: 'Frederiksberg C' },
  { nr: '1836', navn: 'Frederiksberg C' },
  { nr: '1837', navn: 'Frederiksberg C' },
  { nr: '1838', navn: 'Frederiksberg C' },
  { nr: '1839', navn: 'Frederiksberg C' },
  { nr: '1840', navn: 'Frederiksberg C' },
  { nr: '1841', navn: 'Frederiksberg C' },
  { nr: '1842', navn: 'Frederiksberg C' },
  { nr: '1843', navn: 'Frederiksberg C' },
  { nr: '1844', navn: 'Frederiksberg C' },
  { nr: '1845', navn: 'Frederiksberg C' },
  { nr: '1846', navn: 'Frederiksberg C' },
  { nr: '1847', navn: 'Frederiksberg C' },
  { nr: '1848', navn: 'Frederiksberg C' },
  { nr: '1849', navn: 'Frederiksberg C' },
  { nr: '1850', navn: 'Frederiksberg C' },
  { nr: '1851', navn: 'Frederiksberg C' },
  { nr: '1852', navn: 'Frederiksberg C' },
  { nr: '1853', navn: 'Frederiksberg C' },
  { nr: '1854', navn: 'Frederiksberg C' },
  { nr: '1855', navn: 'Frederiksberg C' },
  { nr: '1856', navn: 'Frederiksberg C' },
  { nr: '1857', navn: 'Frederiksberg C' },
  { nr: '1858', navn: 'Frederiksberg C' },
  { nr: '1859', navn: 'Frederiksberg C' },
  { nr: '1860', navn: 'Frederiksberg C' },
  { nr: '1861', navn: 'Frederiksberg C' },
  { nr: '1862', navn: 'Frederiksberg C' },
  { nr: '1863', navn: 'Frederiksberg C' },
  { nr: '1864', navn: 'Frederiksberg C' },
  { nr: '1865', navn: 'Frederiksberg C' },
  { nr: '1866', navn: 'Frederiksberg C' },
  { nr: '1867', navn: 'Frederiksberg C' },
  { nr: '1868', navn: 'Frederiksberg C' },
  { nr: '1869', navn: 'Frederiksberg C' },
  { nr: '1870', navn: 'Frederiksberg C' },
  { nr: '1871', navn: 'Frederiksberg C' },
  { nr: '1872', navn: 'Frederiksberg C' },
  { nr: '1873', navn: 'Frederiksberg C' },
  { nr: '1874', navn: 'Frederiksberg C' },
  { nr: '1875', navn: 'Frederiksberg C' },
  { nr: '1876', navn: 'Frederiksberg C' },
  { nr: '1877', navn: 'Frederiksberg C' },
  { nr: '1878', navn: 'Frederiksberg C' },
  { nr: '1879', navn: 'Frederiksberg C' },
  { nr: '1880', navn: 'Frederiksberg C' },
  { nr: '1881', navn: 'Frederiksberg C' },
  { nr: '1882', navn: 'Frederiksberg C' },
  { nr: '1883', navn: 'Frederiksberg C' },
  { nr: '1884', navn: 'Frederiksberg C' },
  { nr: '1885', navn: 'Frederiksberg C' },
  { nr: '1886', navn: 'Frederiksberg C' },
  { nr: '1887', navn: 'Frederiksberg C' },
  { nr: '1888', navn: 'Frederiksberg C' },
  { nr: '1889', navn: 'Frederiksberg C' },
  { nr: '1890', navn: 'Frederiksberg C' },
  { nr: '1891', navn: 'Frederiksberg C' },
  { nr: '1892', navn: 'Frederiksberg C' },
  { nr: '1893', navn: 'Frederiksberg C' },
  { nr: '1894', navn: 'Frederiksberg C' },
  { nr: '1895', navn: 'Frederiksberg C' },
  { nr: '1896', navn: 'Frederiksberg C' },
  { nr: '1897', navn: 'Frederiksberg C' },
  { nr: '1898', navn: 'Frederiksberg C' },
  { nr: '1899', navn: 'Frederiksberg C' },
  { nr: '1900', navn: 'Frederiksberg C' },
  { nr: '1901', navn: 'Frederiksberg C' },
  { nr: '1902', navn: 'Frederiksberg C' },
  { nr: '1903', navn: 'Frederiksberg C' },
  { nr: '1904', navn: 'Frederiksberg C' },
  { nr: '1905', navn: 'Frederiksberg C' },
  { nr: '1906', navn: 'Frederiksberg C' },
  { nr: '1907', navn: 'Frederiksberg C' },
  { nr: '1908', navn: 'Frederiksberg C' },
  { nr: '1909', navn: 'Frederiksberg C' },
  { nr: '1910', navn: 'Frederiksberg C' },
  { nr: '1911', navn: 'Frederiksberg C' },
  { nr: '1912', navn: 'Frederiksberg C' },
  { nr: '1913', navn: 'Frederiksberg C' },
  { nr: '1914', navn: 'Frederiksberg C' },
  { nr: '1915', navn: 'Frederiksberg C' },
  { nr: '1916', navn: 'Frederiksberg C' },
  { nr: '1917', navn: 'Frederiksberg C' },
  { nr: '1918', navn: 'Frederiksberg C' },
  { nr: '1919', navn: 'Frederiksberg C' },
  { nr: '1920', navn: 'Frederiksberg C' },
  { nr: '1921', navn: 'Frederiksberg C' },
  { nr: '1922', navn: 'Frederiksberg C' },
  { nr: '1923', navn: 'Frederiksberg C' },
  { nr: '1924', navn: 'Frederiksberg C' },
  { nr: '1925', navn: 'Frederiksberg C' },
  { nr: '1926', navn: 'Frederiksberg C' },
  { nr: '1927', navn: 'Frederiksberg C' },
  { nr: '1928', navn: 'Frederiksberg C' },
  { nr: '1929', navn: 'Frederiksberg C' },
  { nr: '1930', navn: 'Frederiksberg C' },
  { nr: '1931', navn: 'Frederiksberg C' },
  { nr: '1932', navn: 'Frederiksberg C' },
  { nr: '1933', navn: 'Frederiksberg C' },
  { nr: '1934', navn: 'Frederiksberg C' },
  { nr: '1935', navn: 'Frederiksberg C' },
  { nr: '1936', navn: 'Frederiksberg C' },
  { nr: '1937', navn: 'Frederiksberg C' },
  { nr: '1938', navn: 'Frederiksberg C' },
  { nr: '1939', navn: 'Frederiksberg C' },
  { nr: '1940', navn: 'Frederiksberg C' },
  { nr: '1941', navn: 'Frederiksberg C' },
  { nr: '1942', navn: 'Frederiksberg C' },
  { nr: '1943', navn: 'Frederiksberg C' },
  { nr: '1944', navn: 'Frederiksberg C' },
  { nr: '1945', navn: 'Frederiksberg C' },
  { nr: '1946', navn: 'Frederiksberg C' },
  { nr: '1947', navn: 'Frederiksberg C' },
  { nr: '1948', navn: 'Frederiksberg C' },
  { nr: '1949', navn: 'Frederiksberg C' },
  { nr: '1950', navn: 'Frederiksberg C' },
  { nr: '1951', navn: 'Frederiksberg C' },
  { nr: '1952', navn: 'Frederiksberg C' },
  { nr: '1953', navn: 'Frederiksberg C' },
  { nr: '1954', navn: 'Frederiksberg C' },
  { nr: '1955', navn: 'Frederiksberg C' },
  { nr: '1956', navn: 'Frederiksberg C' },
  { nr: '1957', navn: 'Frederiksberg C' },
  { nr: '1958', navn: 'Frederiksberg C' },
  { nr: '1959', navn: 'Frederiksberg C' },
  { nr: '1960', navn: 'Frederiksberg C' },
  { nr: '1961', navn: 'Frederiksberg C' },
  { nr: '1962', navn: 'Frederiksberg C' },
  { nr: '1963', navn: 'Frederiksberg C' },
  { nr: '1964', navn: 'Frederiksberg C' },
  { nr: '1965', navn: 'Frederiksberg C' },
  { nr: '1966', navn: 'Frederiksberg C' },
  { nr: '1967', navn: 'Frederiksberg C' },
  { nr: '1968', navn: 'Frederiksberg C' },
  { nr: '1969', navn: 'Frederiksberg C' },
  { nr: '1970', navn: 'Frederiksberg C' },
  { nr: '1971', navn: 'Frederiksberg C' },
  { nr: '1972', navn: 'Frederiksberg C' },
  { nr: '1973', navn: 'Frederiksberg C' },
  { nr: '1974', navn: 'Frederiksberg C' },
  { nr: '1975', navn: 'Frederiksberg C' },
  { nr: '1976', navn: 'Frederiksberg C' },
  { nr: '1977', navn: 'Frederiksberg C' },
  { nr: '1978', navn: 'Frederiksberg C' },
  { nr: '1979', navn: 'Frederiksberg C' },
  { nr: '1980', navn: 'Frederiksberg C' },
  { nr: '1981', navn: 'Frederiksberg C' },
  { nr: '1982', navn: 'Frederiksberg C' },
  { nr: '1983', navn: 'Frederiksberg C' },
  { nr: '1984', navn: 'Frederiksberg C' },
  { nr: '1985', navn: 'Frederiksberg C' },
  { nr: '1986', navn: 'Frederiksberg C' },
  { nr: '1987', navn: 'Frederiksberg C' },
  { nr: '1988', navn: 'Frederiksberg C' },
  { nr: '1989', navn: 'Frederiksberg C' },
  { nr: '1990', navn: 'Frederiksberg C' },
  { nr: '1991', navn: 'Frederiksberg C' },
  { nr: '1992', navn: 'Frederiksberg C' },
  { nr: '1993', navn: 'Frederiksberg C' },
  { nr: '1994', navn: 'Frederiksberg C' },
  { nr: '1995', navn: 'Frederiksberg C' },
  { nr: '1996', navn: 'Frederiksberg C' },
  { nr: '1997', navn: 'Frederiksberg C' },
  { nr: '1998', navn: 'Frederiksberg C' },
  { nr: '2000', navn: 'Frederiksberg' },
  { nr: '2100', navn: 'København Ø' },
  { nr: '2150', navn: 'Nordhavn' },
  { nr: '2200', navn: 'København N' },
  { nr: '2300', navn: 'København S' },
  { nr: '2400', navn: 'København NV' },
  { nr: '2450', navn: 'København SV' },
  { nr: '2500', navn: 'Valby' },
  { nr: '2600', navn: 'Glostrup' },
  { nr: '2605', navn: 'Brøndby' },
  { nr: '2610', navn: 'Rødovre' },
  { nr: '2620', navn: 'Albertslund' },
  { nr: '2625', navn: 'Vallensbæk' },
  { nr: '2630', navn: 'Taastrup' },
  { nr: '2635', navn: 'Ishøj' },
  { nr: '2640', navn: 'Hedehusene' },
  { nr: '2650', navn: 'Hvidovre' },
  { nr: '2660', navn: 'Brøndby Strand' },
  { nr: '2665', navn: 'Vallensbæk Strand' },
  { nr: '2670', navn: 'Greve' },
  { nr: '2680', navn: 'Solrød Strand' },
  { nr: '2690', navn: 'Karlslunde' },
  { nr: '2700', navn: 'Brønshøj' },
  { nr: '2720', navn: 'Vanløse' },
  { nr: '2730', navn: 'Herlev' },
  { nr: '2740', navn: 'Skovlunde' },
  { nr: '2750', navn: 'Ballerup' },
  { nr: '2760', navn: 'Måløv' },
  { nr: '2765', navn: 'Smørum' },
  { nr: '2770', navn: 'Kastrup' },
  { nr: '2791', navn: 'Dragør' },
  { nr: '2800', navn: 'Kongens Lyngby' },
  { nr: '2820', navn: 'Gentofte' },
  { nr: '2830', navn: 'Virum' },
  { nr: '2840', navn: 'Holte' },
  { nr: '2850', navn: 'Nærum' },
  { nr: '2860', navn: 'Søborg' },
  { nr: '2870', navn: 'Dyssegård' },
  { nr: '2880', navn: 'Bagsværd' },
  { nr: '2900', navn: 'Hellerup' },
  { nr: '2920', navn: 'Charlottenlund' },
  { nr: '2930', navn: 'Klampenborg' },
  { nr: '2942', navn: 'Skodsborg' },
  { nr: '2950', navn: 'Vedbæk' },
  { nr: '2960', navn: 'Rungsted Kyst' },
  { nr: '2970', navn: 'Hørsholm' },
  { nr: '2980', navn: 'Kokkedal' },
  { nr: '2990', navn: 'Nivå' },
  { nr: '3000', navn: 'Helsingør' },
  { nr: '3050', navn: 'Humlebæk' },
  { nr: '3060', navn: 'Espergærde' },
  { nr: '3070', navn: 'Snekkersten' },
  { nr: '3080', navn: 'Tikøb' },
  { nr: '3100', navn: 'Hornbæk' },
  { nr: '3120', navn: 'Dronningmølle' },
  { nr: '3140', navn: 'Ålsgårde' },
  { nr: '3150', navn: 'Hellebæk' },
  { nr: '3200', navn: 'Helsinge' },
  { nr: '3210', navn: 'Vejby' },
  { nr: '3220', navn: 'Tisvildeleje' },
  { nr: '3230', navn: 'Græsted' },
  { nr: '3250', navn: 'Gilleleje' },
  { nr: '3300', navn: 'Frederiksværk' },
  { nr: '3310', navn: 'Ølsted' },
  { nr: '3320', navn: 'Skævinge' },
  { nr: '3330', navn: 'Gørløse' },
  { nr: '3360', navn: 'Liseleje' },
  { nr: '3370', navn: 'Melby' },
  { nr: '3390', navn: 'Hundested' },
  { nr: '3400', navn: 'Hillerød' },
  { nr: '3450', navn: 'Allerød' },
  { nr: '3460', navn: 'Birkerød' },
  { nr: '3480', navn: 'Fredensborg' },
  { nr: '3490', navn: 'Kvistgård' },
  { nr: '3500', navn: 'Værløse' },
  { nr: '3520', navn: 'Farum' },
  { nr: '3540', navn: 'Lynge' },
  { nr: '3550', navn: 'Slangerup' },
  { nr: '3600', navn: 'Frederikssund' },
  { nr: '3630', navn: 'Jægerspris' },
  { nr: '3650', navn: 'Ølstykke' },
  { nr: '3660', navn: 'Stenløse' },
  { nr: '3670', navn: 'Veksø Sjælland' },
  { nr: '3700', navn: 'Rønne' },
  { nr: '3720', navn: 'Aakirkeby' },
  { nr: '3730', navn: 'Nexø' },
  { nr: '3740', navn: 'Svaneke' },
  { nr: '3751', navn: 'Østermarie' },
  { nr: '3760', navn: 'Gudhjem' },
  { nr: '3770', navn: 'Allinge' },
  { nr: '3782', navn: 'Klemensker' },
  { nr: '3790', navn: 'Hasle' },
  { nr: '4000', navn: 'Roskilde' },
  { nr: '4030', navn: 'Tune' },
  { nr: '4040', navn: 'Jyllinge' },
  { nr: '4050', navn: 'Skibby' },
  { nr: '4060', navn: 'Kirke Såby' },
  { nr: '4070', navn: 'Kirke Hyllinge' },
  { nr: '4100', navn: 'Ringsted' },
  { nr: '4130', navn: 'Viby Sjælland' },
  { nr: '4140', navn: 'Borup' },
  { nr: '4160', navn: 'Herlufmagle' },
  { nr: '4171', navn: 'Glumsø' },
  { nr: '4173', navn: 'Fjenneslev' },
  { nr: '4174', navn: 'Jystrup Midtsj' },
  { nr: '4180', navn: 'Sorø' },
  { nr: '4190', navn: 'Munke Bjergby' },
  { nr: '4200', navn: 'Slagelse' },
  { nr: '4220', navn: 'Korsør' },
  { nr: '4230', navn: 'Skælskør' },
  { nr: '4241', navn: 'Vemmelev' },
  { nr: '4242', navn: 'Boeslunde' },
  { nr: '4243', navn: 'Rude' },
  { nr: '4244', navn: 'Agersø' },
  { nr: '4245', navn: 'Omø' },
  { nr: '4250', navn: 'Fuglebjerg' },
  { nr: '4261', navn: 'Dalmose' },
  { nr: '4262', navn: 'Sandved' },
  { nr: '4270', navn: 'Høng' },
  { nr: '4281', navn: 'Gørlev' },
  { nr: '4291', navn: 'Ruds Vedby' },
  { nr: '4293', navn: 'Dianalund' },
  { nr: '4295', navn: 'Stenlille' },
  { nr: '4296', navn: 'Nyrup' },
  { nr: '4300', navn: 'Holbæk' },
  { nr: '4305', navn: 'Orø' },
  { nr: '4320', navn: 'Lejre' },
  { nr: '4330', navn: 'Hvalsø' },
  { nr: '4340', navn: 'Tølløse' },
  { nr: '4350', navn: 'Ugerløse' },
  { nr: '4360', navn: 'Kirke Eskilstrup' },
  { nr: '4370', navn: 'Store Merløse' },
  { nr: '4390', navn: 'Vipperød' },
  { nr: '4400', navn: 'Kalundborg' },
  { nr: '4420', navn: 'Regstrup' },
  { nr: '4440', navn: 'Mørkøv' },
  { nr: '4450', navn: 'Jyderup' },
  { nr: '4460', navn: 'Snertinge' },
  { nr: '4470', navn: 'Svebølle' },
  { nr: '4480', navn: 'Store Fuglede' },
  { nr: '4490', navn: 'Jerslev Sjælland' },
  { nr: '4500', navn: 'Nykøbing Sj' },
  { nr: '4520', navn: 'Svinninge' },
  { nr: '4532', navn: 'Gislinge' },
  { nr: '4534', navn: 'Hørve' },
  { nr: '4540', navn: 'Fårevejle' },
  { nr: '4550', navn: 'Asnæs' },
  { nr: '4560', navn: 'Vig' },
  { nr: '4571', navn: 'Grevinge' },
  { nr: '4572', navn: 'Nørre Asmindrup' },
  { nr: '4573', navn: 'Højby' },
  { nr: '4581', navn: 'Rørvig' },
  { nr: '4583', navn: 'Sjællands Odde' },
  { nr: '4591', navn: 'Føllenslev' },
  { nr: '4592', navn: 'Sejerø' },
  { nr: '4593', navn: 'Eskebjerg' },
  { nr: '4600', navn: 'Køge' },
  { nr: '4621', navn: 'Gadstrup' },
  { nr: '4622', navn: 'Havdrup' },
  { nr: '4623', navn: 'Lille Skensved' },
  { nr: '4632', navn: 'Bjæverskov' },
  { nr: '4640', navn: 'Faxe' },
  { nr: '4652', navn: 'Hårlev' },
  { nr: '4653', navn: 'Karise' },
  { nr: '4654', navn: 'Faxe Ladeplads' },
  { nr: '4660', navn: 'Store Heddinge' },
  { nr: '4671', navn: 'Strøby' },
  { nr: '4672', navn: 'Klippinge' },
  { nr: '4673', navn: 'Rødvig Stevns' },
  { nr: '4681', navn: 'Herfølge' },
  { nr: '4682', navn: 'Tureby' },
  { nr: '4683', navn: 'Rønnede' },
  { nr: '4684', navn: 'Holmegaard' },
  { nr: '4690', navn: 'Haslev' },
  { nr: '4700', navn: 'Næstved' },
  { nr: '4720', navn: 'Præstø' },
  { nr: '4733', navn: 'Tappernøje' },
  { nr: '4735', navn: 'Mern' },
  { nr: '4736', navn: 'Karrebæksminde' },
  { nr: '4750', navn: 'Lundby' },
  { nr: '4760', navn: 'Vordingborg' },
  { nr: '4771', navn: 'Kalvehave' },
  { nr: '4772', navn: 'Langebæk' },
  { nr: '4773', navn: 'Stensved' },
  { nr: '4780', navn: 'Stege' },
  { nr: '4791', navn: 'Borre' },
  { nr: '4792', navn: 'Askeby' },
  { nr: '4793', navn: 'Bogø By' },
  { nr: '4800', navn: 'Nykøbing F' },
  { nr: '4840', navn: 'Nørre Alslev' },
  { nr: '4850', navn: 'Stubbekøbing' },
  { nr: '4862', navn: 'Guldborg' },
  { nr: '4863', navn: 'Eskilstrup' },
  { nr: '4871', navn: 'Horbelev' },
  { nr: '4872', navn: 'Idestrup' },
  { nr: '4873', navn: 'Væggerløse' },
  { nr: '4874', navn: 'Gedser' },
  { nr: '4880', navn: 'Nysted' },
  { nr: '4891', navn: 'Toreby L' },
  { nr: '4892', navn: 'Kettinge' },
  { nr: '4894', navn: 'Øster Ulslev' },
  { nr: '4895', navn: 'Errindlev' },
  { nr: '4900', navn: 'Nakskov' },
  { nr: '4912', navn: 'Harpelunde' },
  { nr: '4913', navn: 'Horslunde' },
  { nr: '4920', navn: 'Søllested' },
  { nr: '4930', navn: 'Maribo' },
  { nr: '4941', navn: 'Bandholm' },
  { nr: '4943', navn: 'Torrig L' },
  { nr: '4944', navn: 'Fejø' },
  { nr: '4945', navn: 'Femø' },
  { nr: '4951', navn: 'Nørreballe' },
  { nr: '4952', navn: 'Stokkemarke' },
  { nr: '4953', navn: 'Vesterborg' },
  { nr: '4960', navn: 'Holeby' },
  { nr: '4970', navn: 'Rødby' },
  { nr: '4983', navn: 'Dannemare' },
  { nr: '4990', navn: 'Sakskøbing' },
  { nr: '5000', navn: 'Odense C' },
  { nr: '5200', navn: 'Odense V' },
  { nr: '5210', navn: 'Odense NV' },
  { nr: '5220', navn: 'Odense SØ' },
  { nr: '5230', navn: 'Odense M' },
  { nr: '5240', navn: 'Odense NØ' },
  { nr: '5250', navn: 'Odense SV' },
  { nr: '5260', navn: 'Odense S' },
  { nr: '5270', navn: 'Odense N' },
  { nr: '5290', navn: 'Marslev' },
  { nr: '5300', navn: 'Kerteminde' },
  { nr: '5320', navn: 'Agedrup' },
  { nr: '5330', navn: 'Munkebo' },
  { nr: '5350', navn: 'Rynkeby' },
  { nr: '5370', navn: 'Mesinge' },
  { nr: '5380', navn: 'Dalby' },
  { nr: '5390', navn: 'Martofte' },
  { nr: '5400', navn: 'Bogense' },
  { nr: '5450', navn: 'Otterup' },
  { nr: '5462', navn: 'Morud' },
  { nr: '5463', navn: 'Harndrup' },
  { nr: '5464', navn: 'Brenderup Fyn' },
  { nr: '5466', navn: 'Asperup' },
  { nr: '5471', navn: 'Søndersø' },
  { nr: '5474', navn: 'Veflinge' },
  { nr: '5485', navn: 'Skamby' },
  { nr: '5491', navn: 'Blommenslyst' },
  { nr: '5492', navn: 'Vissenbjerg' },
  { nr: '5500', navn: 'Middelfart' },
  { nr: '5540', navn: 'Ullerslev' },
  { nr: '5550', navn: 'Langeskov' },
  { nr: '5560', navn: 'Aarup' },
  { nr: '5580', navn: 'Nørre Aaby' },
  { nr: '5591', navn: 'Gelsted' },
  { nr: '5592', navn: 'Ejby' },
  { nr: '5600', navn: 'Faaborg' },
  { nr: '5602', navn: 'Avernakø' },
  { nr: '5610', navn: 'Assens' },
  { nr: '5620', navn: 'Glamsbjerg' },
  { nr: '5631', navn: 'Ebberup' },
  { nr: '5642', navn: 'Millinge' },
  { nr: '5672', navn: 'Broby' },
  { nr: '5683', navn: 'Haarby' },
  { nr: '5690', navn: 'Tommerup' },
  { nr: '5700', navn: 'Svendborg' },
  { nr: '5750', navn: 'Ringe' },
  { nr: '5762', navn: 'Vester Skerninge' },
  { nr: '5771', navn: 'Stenstrup' },
  { nr: '5772', navn: 'Kværndrup' },
  { nr: '5792', navn: 'Årslev' },
  { nr: '5800', navn: 'Nyborg' },
  { nr: '5853', navn: 'Ørbæk' },
  { nr: '5854', navn: 'Gislev' },
  { nr: '5856', navn: 'Ryslinge' },
  { nr: '5863', navn: 'Ferritslev Fyn' },
  { nr: '5871', navn: 'Frørup' },
  { nr: '5874', navn: 'Hesselager' },
  { nr: '5881', navn: 'Skårup Fyn' },
  { nr: '5882', navn: 'Vejstrup' },
  { nr: '5883', navn: 'Oure' },
  { nr: '5884', navn: 'Gudme' },
  { nr: '5892', navn: 'Gudbjerg Sydfyn' },
  { nr: '5900', navn: 'Rudkøbing' },
  { nr: '5932', navn: 'Humble' },
  { nr: '5935', navn: 'Bagenkop' },
  { nr: '5943', navn: 'Strynø' },
  { nr: '5953', navn: 'Tranekær' },
  { nr: '5960', navn: 'Marstal' },
  { nr: '5970', navn: 'Ærøskøbing' },
  { nr: '5985', navn: 'Søby Ærø' },
  { nr: '6000', navn: 'Kolding' },
  { nr: '6040', navn: 'Egtved' },
  { nr: '6051', navn: 'Almind' },
  { nr: '6052', navn: 'Viuf' },
  { nr: '6064', navn: 'Jordrup' },
  { nr: '6070', navn: 'Christiansfeld' },
  { nr: '6091', navn: 'Bjert' },
  { nr: '6092', navn: 'Sønder Stenderup' },
  { nr: '6093', navn: 'Sjølund' },
  { nr: '6094', navn: 'Hejls' },
  { nr: '6100', navn: 'Haderslev' },
  { nr: '6200', navn: 'Aabenraa' },
  { nr: '6230', navn: 'Rødekro' },
  { nr: '6240', navn: 'Løgumkloster' },
  { nr: '6261', navn: 'Bredebro' },
  { nr: '6270', navn: 'Tønder' },
  { nr: '6280', navn: 'Højer' },
  { nr: '6300', navn: 'Gråsten' },
  { nr: '6310', navn: 'Broager' },
  { nr: '6320', navn: 'Egernsund' },
  { nr: '6330', navn: 'Padborg' },
  { nr: '6340', navn: 'Kruså' },
  { nr: '6360', navn: 'Tinglev' },
  { nr: '6372', navn: 'Bylderup-Bov' },
  { nr: '6392', navn: 'Bolderslev' },
  { nr: '6400', navn: 'Sønderborg' },
  { nr: '6430', navn: 'Nordborg' },
  { nr: '6440', navn: 'Augustenborg' },
  { nr: '6470', navn: 'Sydals' },
  { nr: '6500', navn: 'Vojens' },
  { nr: '6510', navn: 'Gram' },
  { nr: '6520', navn: 'Toftlund' },
  { nr: '6534', navn: 'Agerskov' },
  { nr: '6535', navn: 'Branderup J' },
  { nr: '6541', navn: 'Bevtoft' },
  { nr: '6560', navn: 'Sommersted' },
  { nr: '6580', navn: 'Vamdrup' },
  { nr: '6600', navn: 'Vejen' },
  { nr: '6621', navn: 'Gesten' },
  { nr: '6622', navn: 'Bække' },
  { nr: '6623', navn: 'Vorbasse' },
  { nr: '6630', navn: 'Rødding' },
  { nr: '6640', navn: 'Lunderskov' },
  { nr: '6650', navn: 'Brørup' },
  { nr: '6660', navn: 'Lintrup' },
  { nr: '6670', navn: 'Holsted' },
  { nr: '6682', navn: 'Hovborg' },
  { nr: '6683', navn: 'Føvling' },
  { nr: '6690', navn: 'Gørding' },
  { nr: '6700', navn: 'Esbjerg' },
  { nr: '6705', navn: 'Esbjerg Ø' },
  { nr: '6710', navn: 'Esbjerg V' },
  { nr: '6715', navn: 'Esbjerg N' },
  { nr: '6720', navn: 'Fanø' },
  { nr: '6731', navn: 'Tjæreborg' },
  { nr: '6740', navn: 'Bramming' },
  { nr: '6752', navn: 'Glejbjerg' },
  { nr: '6753', navn: 'Agerbæk' },
  { nr: '6760', navn: 'Ribe' },
  { nr: '6771', navn: 'Gredstedbro' },
  { nr: '6780', navn: 'Skærbæk' },
  { nr: '6792', navn: 'Rømø' },
  { nr: '6800', navn: 'Varde' },
  { nr: '6818', navn: 'Årre' },
  { nr: '6823', navn: 'Ansager' },
  { nr: '6830', navn: 'Nørre Nebel' },
  { nr: '6840', navn: 'Oksbøl' },
  { nr: '6851', navn: 'Janderup Vestj' },
  { nr: '6852', navn: 'Billum' },
  { nr: '6853', navn: 'Vejers Strand' },
  { nr: '6854', navn: 'Henne' },
  { nr: '6855', navn: 'Outrup' },
  { nr: '6857', navn: 'Blåvand' },
  { nr: '6862', navn: 'Tistrup' },
  { nr: '6870', navn: 'Ølgod' },
  { nr: '6880', navn: 'Tarm' },
  { nr: '6893', navn: 'Hemmet' },
  { nr: '6900', navn: 'Skjern' },
  { nr: '6920', navn: 'Videbæk' },
  { nr: '6933', navn: 'Kibæk' },
  { nr: '6940', navn: 'Lem St' },
  { nr: '6950', navn: 'Ringkøbing' },
  { nr: '6960', navn: 'Hvide Sande' },
  { nr: '6971', navn: 'Spjald' },
  { nr: '6973', navn: 'Ørnhøj' },
  { nr: '6980', navn: 'Tim' },
  { nr: '6990', navn: 'Ulfborg' },
  { nr: '7000', navn: 'Fredericia' },
  { nr: '7080', navn: 'Børkop' },
  { nr: '7100', navn: 'Vejle' },
  { nr: '7120', navn: 'Vejle Øst' },
  { nr: '7130', navn: 'Juelsminde' },
  { nr: '7140', navn: 'Stouby' },
  { nr: '7150', navn: 'Barrit' },
  { nr: '7160', navn: 'Tørring' },
  { nr: '7171', navn: 'Uldum' },
  { nr: '7173', navn: 'Vonge' },
  { nr: '7182', navn: 'Bredsten' },
  { nr: '7183', navn: 'Randbøl' },
  { nr: '7184', navn: 'Vandel' },
  { nr: '7190', navn: 'Billund' },
  { nr: '7200', navn: 'Grindsted' },
  { nr: '7250', navn: 'Hejnsvig' },
  { nr: '7260', navn: 'Sønder Omme' },
  { nr: '7270', navn: 'Stakroge' },
  { nr: '7280', navn: 'Sønder Felding' },
  { nr: '7300', navn: 'Jelling' },
  { nr: '7321', navn: 'Gadbjerg' },
  { nr: '7323', navn: 'Give' },
  { nr: '7330', navn: 'Brande' },
  { nr: '7361', navn: 'Ejstrupholm' },
  { nr: '7362', navn: 'Hampen' },
  { nr: '7400', navn: 'Herning' },
  { nr: '7430', navn: 'Ikast' },
  { nr: '7441', navn: 'Bording' },
  { nr: '7442', navn: 'Engesvang' },
  { nr: '7451', navn: 'Sunds' },
  { nr: '7470', navn: 'Karup J' },
  { nr: '7480', navn: 'Vildbjerg' },
  { nr: '7490', navn: 'Aulum' },
  { nr: '7500', navn: 'Holstebro' },
  { nr: '7540', navn: 'Haderup' },
  { nr: '7550', navn: 'Sørvad' },
  { nr: '7560', navn: 'Hjerm' },
  { nr: '7570', navn: 'Vemb' },
  { nr: '7600', navn: 'Struer' },
  { nr: '7620', navn: 'Lemvig' },
  { nr: '7650', navn: 'Bøvlingbjerg' },
  { nr: '7660', navn: 'Bækmarksbro' },
  { nr: '7673', navn: 'Harboøre' },
  { nr: '7680', navn: 'Thyborøn' },
  { nr: '7700', navn: 'Thisted' },
  { nr: '7730', navn: 'Hanstholm' },
  { nr: '7741', navn: 'Frøstrup' },
  { nr: '7742', navn: 'Vesløs' },
  { nr: '7752', navn: 'Snedsted' },
  { nr: '7755', navn: 'Bedsted Thy' },
  { nr: '7760', navn: 'Hurup Thy' },
  { nr: '7770', navn: 'Vestervig' },
  { nr: '7790', navn: 'Thyholm' },
  { nr: '7800', navn: 'Skive' },
  { nr: '7830', navn: 'Vinderup' },
  { nr: '7840', navn: 'Højslev' },
  { nr: '7850', navn: 'Stoholm Jyll' },
  { nr: '7860', navn: 'Spøttrup' },
  { nr: '7870', navn: 'Roslev' },
  { nr: '7884', navn: 'Fur' },
  { nr: '7900', navn: 'Nykøbing M' },
  { nr: '7950', navn: 'Erslev' },
  { nr: '7960', navn: 'Karby' },
  { nr: '7970', navn: 'Redsted M' },
  { nr: '7980', navn: 'Vils' },
  { nr: '7990', navn: 'Øster Assels' },
  { nr: '8000', navn: 'Aarhus C' },
  { nr: '8200', navn: 'Aarhus N' },
  { nr: '8210', navn: 'Aarhus V' },
  { nr: '8220', navn: 'Brabrand' },
  { nr: '8230', navn: 'Åbyhøj' },
  { nr: '8240', navn: 'Risskov' },
  { nr: '8250', navn: 'Egå' },
  { nr: '8260', navn: 'Viby J' },
  { nr: '8270', navn: 'Højbjerg' },
  { nr: '8300', navn: 'Odder' },
  { nr: '8305', navn: 'Samsø' },
  { nr: '8310', navn: 'Tranbjerg J' },
  { nr: '8320', navn: 'Mårslet' },
  { nr: '8330', navn: 'Beder' },
  { nr: '8340', navn: 'Malling' },
  { nr: '8350', navn: 'Hundslund' },
  { nr: '8355', navn: 'Solbjerg' },
  { nr: '8361', navn: 'Hasselager' },
  { nr: '8362', navn: 'Hørning' },
  { nr: '8370', navn: 'Hadsten' },
  { nr: '8380', navn: 'Trige' },
  { nr: '8381', navn: 'Tilst' },
  { nr: '8382', navn: 'Hinnerup' },
  { nr: '8400', navn: 'Ebeltoft' },
  { nr: '8410', navn: 'Rønde' },
  { nr: '8420', navn: 'Knebel' },
  { nr: '8444', navn: 'Balle' },
  { nr: '8450', navn: 'Hammel' },
  { nr: '8462', navn: 'Harlev J' },
  { nr: '8464', navn: 'Galten' },
  { nr: '8471', navn: 'Sabro' },
  { nr: '8472', navn: 'Sporup' },
  { nr: '8500', navn: 'Grenaa' },
  { nr: '8520', navn: 'Lystrup' },
  { nr: '8530', navn: 'Hjortshøj' },
  { nr: '8541', navn: 'Skødstrup' },
  { nr: '8543', navn: 'Hornslet' },
  { nr: '8544', navn: 'Mørke' },
  { nr: '8550', navn: 'Ryomgård' },
  { nr: '8560', navn: 'Kolind' },
  { nr: '8570', navn: 'Trustrup' },
  { nr: '8581', navn: 'Nimtofte' },
  { nr: '8585', navn: 'Glesborg' },
  { nr: '8586', navn: 'Ørum Djurs' },
  { nr: '8592', navn: 'Anholt' },
  { nr: '8600', navn: 'Silkeborg' },
  { nr: '8620', navn: 'Kjellerup' },
  { nr: '8632', navn: 'Lemming' },
  { nr: '8641', navn: 'Sorring' },
  { nr: '8643', navn: 'Ans By' },
  { nr: '8653', navn: 'Them' },
  { nr: '8654', navn: 'Bryrup' },
  { nr: '8660', navn: 'Skanderborg' },
  { nr: '8670', navn: 'Låsby' },
  { nr: '8680', navn: 'Ry' },
  { nr: '8700', navn: 'Horsens' },
  { nr: '8721', navn: 'Daugård' },
  { nr: '8722', navn: 'Hedensted' },
  { nr: '8723', navn: 'Løsning' },
  { nr: '8732', navn: 'Hovedgård' },
  { nr: '8740', navn: 'Brædstrup' },
  { nr: '8751', navn: 'Gedved' },
  { nr: '8752', navn: 'Østbirk' },
  { nr: '8762', navn: 'Flemming' },
  { nr: '8763', navn: 'Rask Mølle' },
  { nr: '8765', navn: 'Klovborg' },
  { nr: '8766', navn: 'Nørre Snede' },
  { nr: '8781', navn: 'Stenderup' },
  { nr: '8783', navn: 'Hornsyld' },
  { nr: '8789', navn: 'Endelave' },
  { nr: '8800', navn: 'Viborg' },
  { nr: '8830', navn: 'Tjele' },
  { nr: '8831', navn: 'Løgstrup' },
  { nr: '8832', navn: 'Skals' },
  { nr: '8840', navn: 'Rødkærsbro' },
  { nr: '8850', navn: 'Bjerringbro' },
  { nr: '8860', navn: 'Ulstrup' },
  { nr: '8870', navn: 'Langå' },
  { nr: '8881', navn: 'Thorsø' },
  { nr: '8882', navn: 'Fårvang' },
  { nr: '8883', navn: 'Gjern' },
  { nr: '8900', navn: 'Randers C' },
  { nr: '8920', navn: 'Randers NV' },
  { nr: '8930', navn: 'Randers NØ' },
  { nr: '8940', navn: 'Randers SV' },
  { nr: '8950', navn: 'Ørsted' },
  { nr: '8960', navn: 'Randers SØ' },
  { nr: '8961', navn: 'Allingåbro' },
  { nr: '8963', navn: 'Auning' },
  { nr: '8970', navn: 'Havndal' },
  { nr: '8981', navn: 'Spentrup' },
  { nr: '8983', navn: 'Gjerlev J' },
  { nr: '8990', navn: 'Fårup' },
  { nr: '9000', navn: 'Aalborg' },
  { nr: '9200', navn: 'Aalborg SV' },
  { nr: '9210', navn: 'Aalborg SØ' },
  { nr: '9220', navn: 'Aalborg Øst' },
  { nr: '9230', navn: 'Svenstrup J' },
  { nr: '9240', navn: 'Nibe' },
  { nr: '9260', navn: 'Gistrup' },
  { nr: '9270', navn: 'Klarup' },
  { nr: '9280', navn: 'Storvorde' },
  { nr: '9293', navn: 'Kongerslev' },
  { nr: '9300', navn: 'Sæby' },
  { nr: '9310', navn: 'Vodskov' },
  { nr: '9320', navn: 'Hjallerup' },
  { nr: '9330', navn: 'Dronninglund' },
  { nr: '9340', navn: 'Asaa' },
  { nr: '9352', navn: 'Dybvad' },
  { nr: '9362', navn: 'Gandrup' },
  { nr: '9370', navn: 'Hals' },
  { nr: '9380', navn: 'Vestbjerg' },
  { nr: '9381', navn: 'Sulsted' },
  { nr: '9382', navn: 'Tylstrup' },
  { nr: '9400', navn: 'Nørresundby' },
  { nr: '9430', navn: 'Vadum' },
  { nr: '9440', navn: 'Aabybro' },
  { nr: '9460', navn: 'Brovst' },
  { nr: '9480', navn: 'Løkken' },
  { nr: '9490', navn: 'Pandrup' },
  { nr: '9492', navn: 'Blokhus' },
  { nr: '9493', navn: 'Saltum' },
  { nr: '9500', navn: 'Hobro' },
  { nr: '9510', navn: 'Arden' },
  { nr: '9520', navn: 'Skørping' },
  { nr: '9530', navn: 'Støvring' },
  { nr: '9541', navn: 'Suldrup' },
  { nr: '9550', navn: 'Mariager' },
  { nr: '9560', navn: 'Hadsund' },
  { nr: '9574', navn: 'Bælum' },
  { nr: '9575', navn: 'Terndrup' },
  { nr: '9600', navn: 'Aars' },
  { nr: '9610', navn: 'Nørager' },
  { nr: '9620', navn: 'Aalestrup' },
  { nr: '9631', navn: 'Gedsted' },
  { nr: '9632', navn: 'Møldrup' },
  { nr: '9640', navn: 'Farsø' },
  { nr: '9670', navn: 'Løgstør' },
  { nr: '9681', navn: 'Ranum' },
  { nr: '9690', navn: 'Fjerritslev' },
  { nr: '9700', navn: 'Brønderslev' },
  { nr: '9740', navn: 'Jerslev J' },
  { nr: '9750', navn: 'Østervrå' },
  { nr: '9760', navn: 'Vrå' },
  { nr: '9800', navn: 'Hjørring' },
  { nr: '9830', navn: 'Tårs' },
  { nr: '9850', navn: 'Hirtshals' },
  { nr: '9870', navn: 'Sindal' },
  { nr: '9881', navn: 'Bindslev' },
  { nr: '9900', navn: 'Frederikshavn' },
  { nr: '9940', navn: 'Læsø' },
  { nr: '9970', navn: 'Strandby' },
  { nr: '9981', navn: 'Jerup' },
  { nr: '9982', navn: 'Ålbæk' },
  { nr: '9990', navn: 'Skagen' },
]
